<script lang="ts">
	import UncheckedIcon from '$lib/assets/images/icons/unchecked.svg?component';
	import CheckedIcon from '$lib/assets/images/icons/checked.svg?component';
	import FieldWrapper from './FieldWrapper.svelte';
	import { scale } from 'svelte/transition';

	export let name: string;
	export let label: string;
	let value: boolean = false;
</script>

<FieldWrapper
	{name}
	let:handleUpdate
	on:value={(e) => {
		value = e.detail || '';
	}}
>
	<div class="flex gap-[10px]">
		<div class="relative flex flex-col">
			<input
				class="h-[15px] w-[15px] shrink-0 cursor-pointer appearance-none"
				type="checkbox"
				on:input={(e) => handleUpdate(e.target.checked ? true : null)}
				id={label}
				{name}
				{value}
			/>
			{#if value}
				<span transition:scale class="pointer-events-none absolute top-0">
					<CheckedIcon class="h-[15px] w-[15px]" />
				</span>
			{:else}
				<span transition:scale class="pointer-events-none absolute top-0">
					<UncheckedIcon class="h-[15px] w-[15px]" />
				</span>
			{/if}
		</div>
		<label class="s-QbPPkABxSxL7 -mt-[1px] text-sm/[17px]" for={label}>{@html label}</label>
	</div>
</FieldWrapper>
